"use client";
import { memo } from "react";
import { Tooltip, TooltipProps } from "@mui/material";

const AppTooltip = ({ children, componentsProps, ...props }: TooltipProps) => {
  return (
    <Tooltip
      {...props}
      componentsProps={{
        ...componentsProps,
        tooltip: {
          ...componentsProps?.tooltip,
          sx: {
            fontSize: "12px",
            ...componentsProps?.tooltip?.sx,
          },
        },
      }}
    >
      {children}
    </Tooltip>
  );
};

export default memo(AppTooltip);
